import React, { Component } from 'react';

class Title extends Component {
  render() {
    return <section className="Title"></section>;
  }
}

export default Title;
